import styled from 'styled-components';

export const Message = styled.span`
    font-size: 24px;
    text-align: center;
`;

Message.displayName = 'Message';
